import { render } from "./CreditLoader.vue?vue&type=template&id=0f51792d&scoped=true"
import script from "./CreditLoader.vue?vue&type=script&lang=js"
export * from "./CreditLoader.vue?vue&type=script&lang=js"

import "./CreditLoader.vue?vue&type=style&index=0&id=0f51792d&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0f51792d"]])

export default __exports__